import React, { useEffect } from 'react';
import { useReturnContext } from '../context/ReturnContext';
import './ThankYou.css';

export default function ThankYou({ orderNumber }) {
  const { resetReturnState } = useReturnContext();
  
  // Automatically reset context data and local storage when component is shown
  useEffect(() => {
    // Set a timeout to allow the thank you page to be displayed before resetting
    const timer = setTimeout(() => {
      // We're not calling resetReturnState() here because we want to keep the thank you page visible
      // Instead, we'll just clear localStorage to ensure a refresh goes to step 1
      localStorage.removeItem('returnOrderData');
      localStorage.removeItem('returnSelectedItems');
      localStorage.removeItem('returnType');
      localStorage.removeItem('returnNotes');
      localStorage.removeItem('returnStep');
      localStorage.removeItem('returnSubmitted');
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);
  
  const handleStartNewReturn = () => {
    resetReturnState();
  };
  return (
    <div className="thank-you">
      <div className="icon">
        <i className="fas fa-check-circle"></i>
      </div>
      
      <h2>Thank You!</h2>
      <p>
        Your return request for order {orderNumber} has been submitted successfully.
      </p>
      
      <div className="card mb-6">
        <div className="card-header">
          <h3 className="card-title">What's Next?</h3>
        </div>
        <div className="card-body">
          <ol className="steps-list">
            <li>
              <div className="step-number">1</div>
              <div className="step-content">
                <h4>Confirmation Email</h4>
                <p>You will receive a confirmation email with details about your return request.</p>
              </div>
            </li>
            <li>
              <div className="step-number">2</div>
              <div className="step-content">
                <h4>Review Process</h4>
                <p>Our team will review your request within 1-2 business days.</p>
              </div>
            </li>
            <li>
              <div className="step-number">3</div>
              <div className="step-content">
                <h4>Return Instructions</h4>
                <p>Once approved, you will receive instructions for returning your items.</p>
              </div>
            </li>
            <li>
              <div className="step-number">4</div>
              <div className="step-content">
                <h4>Processing</h4>
                <p>After we receive your returned items, we will process your refund or exchange.</p>
              </div>
            </li>
          </ol>
        </div>
      </div>
      
      <div className="contact-info">
        <p>
          If you have any questions about your return, please contact our customer service team at <a href="mailto:support@dirtywaterdonutshop.com">support@dirtywaterdonutshop.com</a>.
        </p>
      </div>
      
      <div className="text-center mt-6">
        <div className="button-group">
          <button 
            onClick={handleStartNewReturn} 
            className="btn btn-secondary btn-lg mr-3"
          >
            <i className="fas fa-redo mr-2"></i> Start New Return
          </button>
          <a href="/" className="btn btn-primary btn-lg">
            <i className="fas fa-home mr-2"></i> Return to Home
          </a>
        </div>
      </div>
    </div>
  );
}
